"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initMpShopClient = void 0;
var mp_shop_client_1 = require("@bookingcom/mp-shop-client");
var get_mp_shop_url_1 = require("./get-mp-shop-url");
var initMpShopClient = function (params) {
    var env = params.env, _a = params.mock, mock = _a === void 0 ? false : _a, mpShopUrlOverride = params.mpShopUrlOverride, _b = params.mpShopAllowCredentials, mpShopAllowCredentials = _b === void 0 ? false : _b, etStateBlob = params.etStateBlob;
    var mockParam = mock ? '&mock=1' : '';
    var baseConfig = {
        basePath: (0, get_mp_shop_url_1.getMpShopUrl)(env, mpShopUrlOverride),
        queryParamsStringify: function (query) {
            return "".concat((0, mp_shop_client_1.querystring)(query) + mockParam);
        },
        headers: {
            'x-booking-experiment-state': etStateBlob,
        },
    };
    // TODO:: Remove once the tested &
    // archive feature FLIGHTS_WEB_MP_SHOP_ALLOW_CREDENTIALS
    if (mpShopAllowCredentials) {
        baseConfig.credentials = 'include';
    }
    var mpShopConfig = new mp_shop_client_1.Configuration(__assign({}, baseConfig));
    return new mp_shop_client_1.DefaultApi(mpShopConfig);
};
exports.initMpShopClient = initMpShopClient;
